module.exports = __webpack_public_path__ + "static/img/jessicaotero_circle150.e4ee58e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/jessicaotero_circle150.png
// module id = pZ+D
// module chunks = 0